module.exports = __webpack_public_path__ + "static/img/st5.db2cc9b3.png";